import React from 'react';
import { Text, View } from 'react-native';
import { Icon } from 'LocalGluons';

// eslint-disable-next-line import/no-unresolved
import { SUBSCRPTION_TYPE } from 'Pages/PackageInfoScene/getVoyoPackageTexts';
// eslint-disable-next-line import/no-cycle
import { Playouts } from '../BadgeButton';
import defaultStyles from '../styles';

interface ProgressComponentProps {
    playouts: Playouts;
    diff?: number;
}

const ProgressComponent = ({ playouts, diff }: ProgressComponentProps): JSX.Element | null => {
    switch (playouts.type) {
        case SUBSCRPTION_TYPE.TASTING:
            return (
                <Text style={defaultStyles.progressComponentLowerText}>
                    <Text style={defaultStyles.progressComponentHigherText}>
                        {playouts?.playoutsActualCount}
                    </Text>
                    /{playouts.playoutsMaxCount}
                </Text>
            );
        case SUBSCRPTION_TYPE.TRIAL:
            return <Text style={defaultStyles.progressComponentGeneral}>{diff}</Text>;

        case SUBSCRPTION_TYPE.FULL:
            return (
                <View style={defaultStyles.iconContainer}>
                    <Icon style={defaultStyles.icon} name="unlimited" />
                </View>
            );
        default:
            return null;
    }
};

export default ProgressComponent;
